import {gql} from 'apollo-angular';

export const addressesGql = gql`
query ReloadAddressesQuery($participantId: [Int!]) {
  Participant (participantId: $participantId) {
    participantId
    event {
      eventId
    }
    individualConstituent  {
      constituentAddresses {
        postalCode
        city
        constituentAddressId
        address1
        address2
        address3
        primaryFl
        country
        county
        state
        addressType {
          addressTypeId
          name
          description
        }
      }              
    }
  }
}
`;